/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlLoginIp } from './ControlLoginIp';
import {
    ControlLoginIpFromJSON,
    ControlLoginIpFromJSONTyped,
    ControlLoginIpToJSON,
} from './ControlLoginIp';

/**
 * 
 * @export
 * @interface ControlPaginatedLoginIpResponse
 */
export interface ControlPaginatedLoginIpResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedLoginIpResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedLoginIpResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedLoginIpResponse
     */
    total: number;
    /**
     * 
     * @type {Array<ControlLoginIp>}
     * @memberof ControlPaginatedLoginIpResponse
     */
    results: Array<ControlLoginIp>;
}

/**
 * Check if a given object implements the ControlPaginatedLoginIpResponse interface.
 */
export function instanceOfControlPaginatedLoginIpResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedLoginIpResponseFromJSON(json: any): ControlPaginatedLoginIpResponse {
    return ControlPaginatedLoginIpResponseFromJSONTyped(json, false);
}

export function ControlPaginatedLoginIpResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedLoginIpResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(ControlLoginIpFromJSON)),
    };
}

export function ControlPaginatedLoginIpResponseToJSON(value?: ControlPaginatedLoginIpResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'total': value.total,
        'results': ((value.results as Array<any>).map(ControlLoginIpToJSON)),
    };
}

